import ColumnFilterInput from 'src/components/VehicleTable/components/filters/ColumnFilterInput';
import ColumnFilterMultiSelect from 'src/components/VehicleTable/components/filters/ColumnFilterMultiSelect';
import { toSortBy } from './params';

const ENUM_FILTERS = ['stato_corrente', 'stato_disp'];
const PRIMARY_TEXT = ['marca', 'modello'];
const SECONDARY_TEXT = [
	'allestimento',
	'dealer',
	'colore_esterno',
	'colore_interno',
	'trazione',
	'carrozzeria',
	'city',
	'alimentazione',
	'cambio',
	'utente',
];

const SEARCHED = ['nr_ordine', 'codice_costruttore', 'telaio', 'targa'];

export const toServerColumns = (columns: any[]): any[] =>
	columns.map((source) => {
		const column = { ...source };

		delete column.filter;
		delete column.sortType;

		if (column.id === 'data_disp') {
			column.inputType = 'month';
		}

		if (column.id === 'year') {
			column.accessor = 'model_year';
			delete column.Cell;
		}

		if (SEARCHED.includes(column.id)) {
			delete column.PrimaryFilter;
			delete column.SecondaryFilter;
		} else if (PRIMARY_TEXT.includes(column.id)) {
			column.PrimaryFilter = ColumnFilterInput;
			column.inputType = 'text';
			delete column.SecondaryFilter;
			delete column.isCreatable;
		} else if (SECONDARY_TEXT.includes(column.id)) {
			column.SecondaryFilter = ColumnFilterInput;
			column.inputType = 'text';
			delete column.PrimaryFilter;
			delete column.isCreatable;
		} else if (ENUM_FILTERS.includes(column.id)) {
			column.PrimaryFilter = ColumnFilterMultiSelect;
		}

		if (!column.disableSortBy && !toSortBy(column.id)) {
			column.disableSortBy = true;
		}

		return column;
	});
